<template>
  <div class="instruction_box">
    <div class="instruction_box_title">
      <span @click="getReturn">&lt;</span>
      <span>供应计划创建及审批步骤</span>
    </div>
    <el-divider></el-divider>
    <div class="instruction_step">
      <el-steps :space="300" :active="0" finish-status="success">
        <el-step>
          <div slot="title">
            <el-tooltip placement="top">
              <div slot="content">创建煤型–创建煤型，需到煤型管理页，点击新建进行创建操作；<br>
                煤型管理用于管理煤型及价格，可煤型实时价格进行调整；<br>
                煤型价格调整会影响到货运最终扣款；<br>
                煤型停用会影响到煤仓，供应计划的设置，导致煤仓，供应计划及采购方的预约
              </div>
              <span style="cursor:pointer;">创建煤型</span>
            </el-tooltip>
          </div>
        </el-step>
        <el-step>
          <div slot="title">
            <el-tooltip placement="top">
              <div slot="content">创建煤仓–创建煤仓，需到煤仓管理页，点击新建进行创建操作；<br>
                煤仓管理用于管理矿区煤仓，煤仓配置煤型后，方可针对煤仓进行供应计划设置；<br>
                煤仓的调整或停用，会导致供应计划停用，从而导致采购方预约无效 <br>
              </div>
              <span style="cursor:pointer;">创建煤型</span>
            </el-tooltip>
          </div>
        </el-step>
        <el-step>
          <div slot="title">
            <el-tooltip placement="top">
              <div slot="content">创建供应计划–创建供应计划，需到供应计划页，点击新建进行创建操作；<br>
                供应计划用于管理矿区煤仓在不同时间段货物发放量的控制；<br>
                供应计划的调整或停用，会导致供应计划停用，从而导致采购方预约无效
              </div>
              <span style="cursor:pointer;">创建供应计划</span>
            </el-tooltip>
          </div>
        </el-step>
        <el-step>
          <div slot="title">
            <el-tooltip placement="top">
              <div slot="content">创建采购方–创建采购方，需到采购方管理页，点击新建进行创建操作；<br>
                采购方为已与煤矿达成合作的采购方；可管理采购方的基本信息以及预约规则。
              </div>
              <span style="cursor:pointer;">创建采购方</span>
            </el-tooltip>
          </div>
        </el-step>
        <el-step>
          <div slot="title">
            <el-tooltip placement="top">
              <div slot="content">预约审批–采购方成功预约后，可在待审核页面中进行审核，审核时可对提交的申请车辆数进行调整。<br>
                审核通过或驳回，均需在审核详情中查看，并可为待执行与执行中的审核进行剩余车辆释放操作
              </div>
              <span style="cursor:pointer;">预约审批</span>
            </el-tooltip>
          </div>
        </el-step>
      </el-steps>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      size: 'small'
    }
  },
  mounted() {
  },
  methods: {
    getReturn() {
      const _t = this
      _t.$emit('Adjust', false)
    }
  }
}
</script>
<style lang="scss">
  .instruction_box {
    .instruction_box_title {
      padding: 10px;

      span:first-child {
        font-weight: 700;
        font-size: 32px;
        padding-right: 10px;
        cursor: pointer;
        vertical-align: middle;
      }

      span:last-child {
        font-weight: 700;
        font-size: 20px;
        vertical-align: middle;
      }
    }

    .instruction_step {
      width: 80%;
      margin: 0 auto;

      .el-steps {
        .el-step {
          .el-step__head {
            .el-step__line {
              background-color: #0199cc;
              top: 18px;
            }

            .el-step__icon {
              width: 40px;
              height: 40px;
              background-color: #8080ff;
              border: 2px solid #000c17;
              cursor: pointer;

              .el-step__icon-inner {
                color: #fff;
              }
            }
          }

          .el-step__main {
            .el-step__title {
              color: #000c17;
              font-weight: 700;
            }
          }
        }
      }
    }
  }
</style>
